if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};

function asyncVendorsLoad() {
  const scriptsToLoad = [];

  const tag = document.getElementsByTagName("script")[0];
  scriptsToLoad.forEach((s) => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.async = true;
    script.src = s.src;

    script.addEventListener("load", (e) => {
      Shopify.vendors = Shopify.vendors || [];
      Shopify.vendors.push(s.name);
      document.dispatchEvent(new CustomEvent(`${s.name}.loaded`));
    });

    return tag.parentNode.insertBefore(script, tag);
  });
}

function getShopifyLink(fileName, location = "assets") {
  if (!window.Shopify.links) {
    return;
  }

  const baseLink = window.Shopify.links[location];
  return baseLink.replace("XXX.XXX", fileName);
}
